import React from "react"
import FormGroupProduct from "../FormGroupProduct"
import ModalActions from "../ModalActions"
import { IModalCreateGroupProduct } from "./interface"

const ModalCreateGroupProduct = ({
    refresh,
    setRefresh
}: IModalCreateGroupProduct
): React.ReactElement => {

    return (
        <ModalActions
            id="addGroupProduct" 
            title="Adicionar grupo de produto" 
            subtitle=""
        >
            <FormGroupProduct
                refresh={refresh}
                setRefresh={setRefresh}
            />
        </ModalActions>
    )
}

export default ModalCreateGroupProduct